<template>
  <textfield-screen
    :key="'phoneNumber'"
    id="phoneNumber"
    v-model="username"
    :title="$ml.get('enterLoginTitle')"
    :is-not-valid="isNotValid"
    :is-not-valid-message="isNotValidMessage"
    :disabledNextButton="isLoading"
    inputmode="email"
    :maxlength="50"
    :headerImg="1"
    autocomplete="off"
    @next="validLogin"
    @back="back"
    @blur="autofixPhone"
  >
    <!--<template slot="middle">-->
    <!--<div class="faceId link" >-->
    <!--<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M9.1103 15.608C9.32676 15.3102 9.74368 15.2442 10.0415 15.4607C10.5185 15.8073 11.1837 16.1333 12 16.1333C12.8163 16.1333 13.4815 15.8073 13.9585 15.4607C14.2563 15.2442 14.6732 15.3102 14.8897 15.608C15.1061 15.9059 15.0402 16.3228 14.7423 16.5393C14.1185 16.9926 13.1837 17.4666 12 17.4666C10.8163 17.4666 9.88153 16.9926 9.25767 16.5393C8.95982 16.3228 8.89384 15.9059 9.1103 15.608Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M16 8.93335C16.3682 8.93335 16.6667 9.23183 16.6667 9.60002V11.2C16.6667 11.5682 16.3682 11.8667 16 11.8667C15.6318 11.8667 15.3333 11.5682 15.3333 11.2V9.60002C15.3333 9.23183 15.6318 8.93335 16 8.93335Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M7.99999 8.93335C8.36818 8.93335 8.66666 9.23183 8.66666 9.60002V11.2C8.66666 11.5682 8.36818 11.8667 7.99999 11.8667C7.63181 11.8667 7.33333 11.5682 7.33333 11.2V9.60002C7.33333 9.23183 7.63181 8.93335 7.99999 8.93335Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.93335C12.3682 8.93335 12.6666 9.23183 12.6666 9.60002V12.8C12.6666 13.6098 12.0098 14.2667 11.2 14.2667C10.8318 14.2667 10.5333 13.9682 10.5333 13.6C10.5333 13.2318 10.8318 12.9333 11.2 12.9333C11.2734 12.9333 11.3333 12.8734 11.3333 12.8V9.60002C11.3333 9.23183 11.6318 8.93335 12 8.93335Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1333 3.19987C16.1333 2.83168 16.4318 2.5332 16.8 2.5332H19.2C20.4522 2.5332 21.4667 3.54768 21.4667 4.79987V7.19987C21.4667 7.56806 21.1682 7.86654 20.8 7.86654C20.4318 7.86654 20.1333 7.56806 20.1333 7.19987V4.79987C20.1333 4.28406 19.7158 3.86654 19.2 3.86654H16.8C16.4318 3.86654 16.1333 3.56806 16.1333 3.19987Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M2.53333 4.79987C2.53333 3.54768 3.5478 2.5332 4.79999 2.5332H7.19999C7.56818 2.5332 7.86666 2.83168 7.86666 3.19987C7.86666 3.56806 7.56818 3.86654 7.19999 3.86654H4.79999C4.28418 3.86654 3.86666 4.28406 3.86666 4.79987V7.19987C3.86666 7.56806 3.56818 7.86654 3.19999 7.86654C2.8318 7.86654 2.53333 7.56806 2.53333 7.19987V4.79987Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M20.8 16.1333C21.1682 16.1333 21.4667 16.4318 21.4667 16.8V19.2C21.4667 20.4522 20.4522 21.4666 19.2 21.4666H16.8C16.4318 21.4666 16.1333 21.1682 16.1333 20.8C16.1333 20.4318 16.4318 20.1333 16.8 20.1333H19.2C19.7158 20.1333 20.1333 19.7158 20.1333 19.2V16.8C20.1333 16.4318 20.4318 16.1333 20.8 16.1333Z" fill="#5DC18B"/>-->
    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M3.19999 16.1333C3.56818 16.1333 3.86666 16.4318 3.86666 16.8V19.2C3.86666 19.7158 4.28418 20.1333 4.79999 20.1333H7.19999C7.56818 20.1333 7.86666 20.4318 7.86666 20.8C7.86666 21.1682 7.56818 21.4666 7.19999 21.4666H4.79999C3.5478 21.4666 2.53333 20.4522 2.53333 19.2V16.8C2.53333 16.4318 2.8318 16.1333 3.19999 16.1333Z" fill="#5DC18B"/>-->
    <!--</svg>-->
    <!--<p v-text="$ml.get('faceId')"></p>-->
    <!--</div>-->
    <!--</template>-->
    <template slot="middle">
      <p class="helptext">{{ $ml.get('enterLoginHelpText') }}</p>
    </template>
    <template slot="bottomLink">
      <a class="link" v-text="$ml.get('restoreAccountAccess')" @click.prevent="$router.push({name: 'AccessRecoveryStart'})" href="/accessRecovery/">Відновити доступ до акаунту</a>
    </template>
  </textfield-screen>
</template>

<script>
import Vue from 'vue';
import TextfieldScreen from '../../components/layout/textfield-screen';
import {conformToMask} from 'vue-text-mask';
import Profile from '../../helpers/profile';
import {login as apiLogin, getApiErrorMessage, detectionBrowser} from '../../helpers/api';

export default {
  name: 'enterLogin',
  components: {TextfieldScreen},
  data() {
    return {
      isNotValid: false,
      isNotValidMessage: '',
      timeoutShowError: null,
      isLoading: false,
      username: '',
      profileOldData: {},
    };
  },

  watch: {
    username: function(val) {
      Vue.nextTick(() => {
        this.username = val.replace(/[^A-Za-z\.\d-_\@]/g, '');
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    let browser = detectionBrowser();
    if ((browser.name === 'chrome' || browser.name === 'crios') && +browser.version < 67)
      next(vm => {
        vm.$router.push('/errorPage/445');
      });
    else next();
  },

  mounted() {
    this.profileOldData = {
      //AUTH-61
      username: Profile.username,
      otpsend: Profile.otpsend,
      otptype: Profile.otptype,
    };
    Profile.reset();
  },

  methods: {
    autofixPhone: function() {
      if (/^[0-9]{9}$/.test(this.username)) this.username = '380' + this.username;
    },

    validLogin: function(data) {
      let val = data.value;
      if (/^\+?\d+$/.test(val)) {
        this.autofixPhone();
        val = this.username;
        if (/^380[0-9]{9}$/.test(val)) this.login({otptype: 'sms', username: val});
        else this.showNotValidMessage(this.$ml.get('enterLoginErrorPhone'));
        //                    this.showNotValidMessage(this.$ml.get('enterLoginErrorPhone'));
        //                    if (/^0[0-9]{9}$/.test(val) || /^80[0-9]{9}$/.test(val) || /^380[0-9]{9}$/.test(val) || /^7[0-9]{10}$/.test(val)) {
        //                        if (/^0[0-9]{9}$/.test(val))
        //                            val ='38'+val;
        //                        else if ( /^80[0-9]{9}$/.test(val))
        //                            val = '3'+val;
        //                        let text  = conformToMask(val,
        //                            ['+', /\d/, /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
        //                            {guide: false});
        //                        this.login({otptype: 'sms', username: text.conformedValue })
        //                    } else {
        //                        this.isNotValid = true;
        //                        this.timeoutShowError = setTimeout(()=>{this.isNotValid = false}, 2000)
        //                    }
      } else if (val.length > 0) {
        if (val.match(/^.+@([\w\-]+\.){0,3}[a-z]{2,7}$/i)) {
          this.login({otptype: 'email', username: val.toLowerCase()});
        } else {
          this.showNotValidMessage(this.$ml.get('enterLoginErrorEmail'));
        }
      } else {
        this.showNotValidMessage(this.$ml.get('enterLoginErrorEmpty'));
      }
    },

    showNotValidMessage: function(text) {
      if (!text) {
        clearTimeout(this.timeoutShowError);
        return;
      }
      this.isNotValidMessage = text;
      this.isNotValid = true;
      this.timeoutShowError = setTimeout(() => {
        this.isNotValid = false;
      }, 2000);
    },

    login: function(data) {
      if (this.isLoading) return;
      this.isLoading = true;
      Profile.setData(data);
      apiLogin(data)
        .then(
          resp => {
            if (Profile.registration && this.profileOldData.otpsend === true && this.profileOldData.otptype === 'email' && this.profileOldData.username === Profile.username) {
              //AUTH-61
              this.$router.push('/registration/enterPhonePage');
            } else this.$router.push({name: Profile.registration ? 'LoginSendCodeForRegistration' : 'LoginSendCode'});
          },
          err => {
            this.showNotValidMessage(
              getApiErrorMessage(err, {
                '400': this.$ml.get(Profile.otptype === 'sms' ? 'enterLoginErrorPhone' : 'enterLoginErrorEmail'),
              })
            );
          }
        )
        .finally(() => {
          this.isLoading = false;
          // Profile.setData({ otpsend: false });
        });
    },
    back: function() {
      this.$router.push('/login/');
    },
  },
};
</script>

<style lang="scss" scoped>
.helptext {
  margin-top: 42px;
  text-align: left;
}
.faceId {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  p {
    font-weight: 500;
  }
  svg {
    margin-right: 12px;
  }
}
.link {
  color: #5cd69b;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin: 12px 0;
  display: inline-block;
}
@media (min-width: 601px) and (max-width: 750px) {
  .faceId {
    display: none;
  }
  .link {
    font-weight: 500;
  }
}
@media (min-width: 751px) {
  .helptext {
    margin-top: 16px;
  }
  .faceId {
    display: none;
  }
  .link {
    font-weight: 500;
  }
}
</style>
